import { Link } from "react-router-dom";
import { Mail, MapPin, Globe } from "lucide-react";
import Logo from "./Logo";
import { useLang } from "../i18n/LanguageContext";

export default function Footer() {
  const { lang, t } = useLang();
  const year = new Date().getFullYear();
  const base = `/${lang}`;

  const links = [
    ["", t.nav.home],
    ["/services", t.nav.services],
    ["/about", t.nav.about],
    ["/contact", t.nav.contact],
  ];

  return (
    <footer data-testid="site-footer" className="bg-navy-900 text-paper-warm">
      <div className="mx-auto max-w-7xl px-5 py-16 sm:px-8 md:py-20">
        <div className="grid gap-12 md:grid-cols-12">
          <div className="md:col-span-5">
            <Logo light />
            <p className="mt-6 max-w-sm text-base leading-relaxed text-paper-warm/70">
              {t.footer.tagline}
            </p>
          </div>

          <div className="md:col-span-3">
            <h3 className="font-heading text-xs font-bold uppercase tracking-[0.24em] text-paper-warm/50">
              {t.footer.navTitle}
            </h3>
            <ul className="mt-5 space-y-3">
              {links.map(([to, label]) => (
                <li key={to}>
                  <Link
                    to={`${base}${to}`}
                    data-testid={`footer-nav-link-${to === "" ? "home" : to.slice(1)}`}
                    className="text-paper-warm/80 transition-colors duration-200 hover:text-paper-warm"
                  >
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h3 className="font-heading text-xs font-bold uppercase tracking-[0.24em] text-paper-warm/50">
              {t.footer.contactTitle}
            </h3>
            <ul className="mt-5 space-y-3 text-paper-warm/80">
              <li>
                <a href="mailto:info@tonouhmarketing.com" data-testid="footer-email-link" className="inline-flex items-center gap-2.5 transition-colors duration-200 hover:text-paper-warm">
                  <Mail className="h-4 w-4 text-teal-500" />
                  {t.footer.emailLabel}
                </a>
              </li>
              <li className="flex items-center gap-2.5">
                <MapPin className="h-4 w-4 text-teal-500" />
                {t.footer.location}
              </li>
              <li className="flex items-center gap-2.5">
                <Globe className="h-4 w-4 text-teal-500" />
                {t.footer.area}
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 flex flex-col gap-4 border-t border-paper-warm/10 pt-8 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-sm text-paper-warm/50" data-testid="footer-copyright">
            {t.footer.rights.replace("{year}", year)}
          </p>
          <Link
            to={`${base}/privacy`}
            data-testid="footer-privacy-link"
            className="text-sm text-paper-warm/60 transition-colors duration-200 hover:text-paper-warm"
          >
            {t.footer.privacy}
          </Link>
        </div>
      </div>
    </footer>
  );
}
